package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2025_05_24_Day_1
import com.veldekar.components.logs.Log_2025_05_24_Day_2
import com.veldekar.components.widgets.SessionDayHeader
import com.veldekar.components.widgets.SessionMediaItem
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2025-05-24")
@Composable
public fun Log_2025_05_24(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Livin' on a Prayer in Bondōvriar",
        ogTitle = "Livin' on a Prayer in Bondōvriar",
        date = LocalDate(2_025, 5, 24),
        aiHint = "Image show characters with money falling out of their pockets (joke). Title is a reference to the city sounding like the band name Bon Jovi.",
        ogDescription = "The heroes survive Flar’Melkhis, spook a nerd, and portal-hop with pockets full of loot.",
        ogImage = "images/tooMuchGold_small.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
        ogImageAlt = "A hand-drawn illustration of Dirk (left) and Annette (right) whose pockets are literally overflowing with cash and gold.",
    ) {
        SessionDayHeader(dayId = "shimmer-5", dateString = "Shimmer 5")
        Log_2025_05_24_Day_1()
        SessionDayHeader(dayId = "shimmer-6", dateString = "Shimmer 6")
        Log_2025_05_24_Day_2()
        SessionMediaItem(
            image = "images/tooMuchGold.webp",
            linkImage = "images/tooMuchGold.webp",
            description = "A hand-drawn illustration of Dirk (left) and Annette (right) whose pockets are literally overflowing with cash and gold.",
            width = 2_653,
            height = 2_133,
        )
    }
}
